// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_SbI","cls2":"Tabs-cls2_-KF Tabs-cls1_SbI"};